import dayjs from 'dayjs';
/**
 * 格式化数字
 * @param num 需要格式化的数字字符串
 *
 * trimTailDotAndZero(0.0001000)      // 0.0001
 * trimTailDotAndZero(1.0001000)      // 1.0001
 * trimTailDotAndZero(10.0001000)     // 10.0001
 *
 */
export const trimTailDotAndZero = (num?: string | null) => {
  if (!num) return '0';
  return num.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1');
};

/**
 *
 * 格式化为本地展示时间
 *
 * ```ts
 * @param time 时间
 * @param format 格式化方式
 * @return 本地时间展示
 * ```
 */
export type Time = string | number | Date | dayjs.Dayjs;
export const formatLocalTime = (time: Time, format = 'YYYY-MM-DD HH:mm:ss') =>
  `${dayjs.utc(time).local().format(format)}`;
